import { render, staticRenderFns } from "./OwnerInformation.vue?vue&type=template&id=2f59caf8&"
import script from "./OwnerInformation.vue?vue&type=script&lang=js&"
export * from "./OwnerInformation.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports